import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import { FormikProps } from 'formik';
import React from 'react';
import { classNames } from 'shared';

type Props = {
	formik: FormikProps<any>;
	label: string;
	name: string;
	type: string;
	id: string;
	required: boolean;
	placeholder?: string;
};

const Input: React.FC<Props> = ({ formik, name, label, type, id, required, placeholder = '' }) => {
	const { errors, touched, values, handleChange, handleBlur } = formik;
	return (
		<div className='w-full'>
			<label
				htmlFor={id}
				className={classNames(
					errors[name ?? 'default'] && touched[name ?? 'default']
						? 'text-red-500 block text-sm font-medium'
						: 'block text-sm font-medium text-white'
				)}>
				{label}
			</label>
			<div className='mt-1 w-full relative rounded-md shadow-sm'>
				<input
					id={id}
					name={name}
					type={type}
					value={values[name]}
					onChange={handleChange}
					onBlur={handleBlur}
					autoComplete={name}
					required={required}
					placeholder={placeholder}
					className={classNames(
						errors[name] && touched[name]
							? 'block w-full py-3 border-b-2 border-red-500 text-red-900 bg-transparent placeholder-red-500 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm rounded-md'
							: 'block w-full bg-transparent text-sm border-b-2 border-[#FFFFFF66] py-3  text-[#FFFFFF66]'
					)}
				/>
				{errors[name] && touched[name] && (
					<div className='absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none'>
						<ExclamationCircleIcon className='h-5 w-5 text-red-500' aria-hidden='true' />
					</div>
				)}
			</div>
			{errors[name] && touched[name] && (
				<p className='mt-2 text-sm text-red-600' id={id}>
					{errors[name]?.toString()}
				</p>
			)}
		</div>
	);
};

export default Input;
